import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import LoopRoundedIcon from "@mui/icons-material/LoopRounded";
import { IconButton, Tooltip } from "@mui/material";

import { usePlayer } from "@/components/player";

export const PlaybackLoopButton = () => {
  const { t } = useTranslation();

  const { player, setLoop } = usePlayer();

  const handleToggleLoop = useCallback(() => {
    setLoop(!player.loop);
  }, [player.loop, setLoop]);

  return (
    <Tooltip title={t("app.areas.playback.loop")}>
      <IconButton
        color={player.loop ? "primary" : undefined}
        onClick={handleToggleLoop}
        size="small"
      >
        <LoopRoundedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
